import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

// Portal: lleva los botones de acción de una página a la cinta superior
// (LayoutTop), a la derecha de los iconos de la sección. Si el destino no
// existe (ej. layout de sidebar), renderiza los hijos en su sitio original.
export default function RibbonActions({ children, fallback = true }) {
  const [el, setEl] = useState(null);
  useEffect(() => {
    setEl(document.getElementById('ribbon-actions'));
    return () => setEl(null);
  }, []);
  if (el) return createPortal(children, el);
  return fallback ? children : null;
}
